import { render } from "./Mes.vue?vue&type=template&id=2fddedf3"
import script from "./Mes.vue?vue&type=script&lang=js"
export * from "./Mes.vue?vue&type=script&lang=js"

import "./Mes.vue?vue&type=style&index=0&id=2fddedf3&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__